import { render, staticRenderFns } from "./markingPaper.vue?vue&type=template&id=01031b68&scoped=true"
import script from "./markingPaper.vue?vue&type=script&lang=js"
export * from "./markingPaper.vue?vue&type=script&lang=js"
import style0 from "./markingPaper.vue?vue&type=style&index=0&id=01031b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01031b68",
  null
  
)

export default component.exports